<script>
    import {topicMetadata, metadataCollections} from '../area-reports/layers';
    import {getContext} from 'svelte';
    import PrintedMetadataSection from "./PrintedMetadataSection.svelte";

    export let includedTopics;

    const metadataCollectionsById = new Map(metadataCollections.map(mc => [mc.id, mc]));

    const topicMetadataById = new Map(topicMetadata.map(m => [m.id, m]));

    let printing = getContext('printStore');

    function getMetadata(topics, metadataCollectionMap, topicMetadataMap) {
        const includedMcMap = new Map();
        const includedMc = [];

        topics.forEach(topic => {
            const id = topic.id;
            const tm = topicMetadataMap.get(id);
            if (!tm || !tm.provenance) return;

            const mc = includedMcMap.get(tm.provenance);

            if (mc) {
                mc.pertainsTo.push(topic);
            } else {
                includedMcMap.set(tm.provenance, {
                    metadataCollection: metadataCollectionMap.get(tm.provenance),
                    pertainsTo: [topic]
                })
            }
        });

        return [...includedMcMap.values()]
    }

    $: includedMetadata = getMetadata(includedTopics, metadataCollectionsById, topicMetadataById);
</script>

<style>
    .printed-metadata {
        padding: 1em;
    }

    .barred-header {
        display: flex;
        align-items: center;
        min-height: 60px;
        vertical-align: middle;
        border-top: 1px solid #c7c7c8;
        border-bottom: 1px solid #c7c7c8;
        margin-bottom: 20px;
    }

    .barred-header > h3 {
        margin: 0;
    }

    @media print {
        .printed-metadata {
            padding: 1em 0;
        }
    }
</style>

{#if $printing}
    <div class="barred-header">
        <h3>Data source & provenance</h3>
    </div>
    <div class="printed-metadata">
        {#each includedMetadata as item}
            {#each item.metadataCollection.metadata as m}
                <PrintedMetadataSection title={`Data source: ${m.title}`}
                                        pertainsTo={item.pertainsTo}
                                        description={m.description} />
                <!--<div class="metadata-section">
                    <h5>Data source: {m.title}</h5>

                    <p>
                        Pertains to:
                        <i>
                            {#each item.pertainsTo as topic, idx}
                                {topic.title}{idx < item.pertainsTo.length ? ', ' : ''}
                            {/each}
                        </i>
                    </p>

                    {@html m.description}
                </div>-->
            {/each}
        {/each}
    </div>
{/if}
